import React from 'react';
import { Link } from 'react-router-dom';
import styles from './style.module.css';
import * as Routes from '../../../../constants/routes';
import InfoBox from '../../../../common/components/info-box';

const ctaButton = {
    link: `${process.env.PUBLIC_URL}/loan${Routes.CONTACT}`,
    label: 'Start planning your loan today'
};

const emailButton = {
    link: `${process.env.PUBLIC_URL}/loan${Routes.STEPFIVE}`,
    label: 'Email Copy'
};

const tooltip = {
    title: 'Did you know?',
    content: 'Talk about incentive to pay off loan early.'
};

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>Payment Schedule</h1>
        <p>Here is the payment schedule based on your estimated loan.</p>
        <div className={styles.accordionList}>
            <div className={styles.accordionItemActive}>
                <button className={styles.accordionHeader} title='Year 1'>
                    <span className={styles.accordionTitle}>Year 1</span>
                    <span className={styles.accordionTitle}>Balance: <strong>$400,000</strong></span>
                </button>
                <div className={styles.accordionContent}>
                    <p className={styles.text}>Payment: <strong>$100,000</strong></p>
                    <p className={styles.text}>Principal: <strong>$250</strong></p>
                    <p className={styles.text}>Interest: <strong>$100</strong></p>
                </div>
            </div>
            <div className={styles.accordionItem}>
                <button className={styles.accordionHeader} title='Year 2'>
                    <span className={styles.accordionTitle}>Year 2</span>
                    <span className={styles.accordionTitle}>Balance: <strong>$300,000</strong></span>
                </button>
                <div className={styles.accordionContent}>
                    <p className={styles.text}>Payment: <strong>$100,000</strong></p>
                    <p className={styles.text}>Principal: <strong>$250</strong></p>
                    <p className={styles.text}>Interest: <strong>$100</strong></p>
                </div>
            </div>
            <div className={styles.accordionItem}>
                <button className={styles.accordionHeader} title='Year 3'>
                    <span className={styles.accordionTitle}>Year 3</span>
                    <span className={styles.accordionTitle}>Balance: <strong>$200,000</strong></span>
                </button>
                <div className={styles.accordionContent}>
                    <p className={styles.text}>Payment: <strong>$100,000</strong></p>
                    <p className={styles.text}>Principal: <strong>$250</strong></p>
                    <p className={styles.text}>Interest: <strong>$100</strong></p>
                </div>
            </div>
            <div className={styles.accordionItem}>
                <button className={styles.accordionHeader} title='Year 4'>
                    <span className={styles.accordionTitle}>Year 4</span>
                    <span className={styles.accordionTitle}>Balance: <strong>$100,000</strong></span>
                </button>
                <div className={styles.accordionContent}>
                    <p className={styles.text}>Payment: <strong>$100,000</strong></p>
                    <p className={styles.text}>Principal: <strong>$250</strong></p>
                    <p className={styles.text}>Interest: <strong>$100</strong></p>
                </div>
            </div>
            <div className={styles.accordionItem}>
                <button className={styles.accordionHeader} title='Year 5'>
                    <span className={styles.accordionTitle}>Year 5</span>
                    <span className={styles.accordionTitle}>Balance: <strong>$0</strong></span>
                </button>
                <div className={styles.accordionContent}>
                    <p className={styles.text}>Payment: <strong>$100,000</strong></p>
                    <p className={styles.text}>Principal: <strong>$250</strong></p>
                    <p className={styles.text}>Interest: <strong>$100</strong></p>
                </div>
            </div>
        </div>
        <InfoBox
            title={tooltip.title}
            content={tooltip.content}
        />
        <Link
            to={ctaButton.link}
            className={styles.ctaButton}
            title={ctaButton.label}
        >
            {ctaButton.label}
        </Link>
        <Link
            to={emailButton.link}
            className={styles.outlineButton}
            title={emailButton.label}
        >
            {emailButton.label}
        </Link>
    </div>
);
